export enum LegalPersonalityEnum {
  PESSOA_FISICA = "Pessoa Física",
  PESSOA_JURIDICA = "Pessoa Jurídica",
}

export enum LegalPersonalityIdEnum {
  "Pessoa Física" = "1",
  "Pessoa Jurídica" = "2",
}

export function getLegalPersonalityDescriptionByValue(value: string) {
  const indexOfS = Object.values(LegalPersonalityIdEnum).indexOf(
    value as unknown as LegalPersonalityIdEnum
  );

  const key = Object.keys(LegalPersonalityIdEnum)[indexOfS];

  return key;
}
